import React, { useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';

function CommonConfigPage({ children, title, table, dialog, getNewConfigObject }) {

    if (!title) {
        console.warn("Prop 'title' is used as an identifier in this component. Please supply the prop with a value.")
    }

    const [refreshList, setRefreshList] = useState(0);
    const [showDialog, setShowDialog] = useState(false);
    const [dialogData, setDialogData] = useState({ name: "" });

    const showEditDialog = (dialogData) => {
        setDialogData(dialogData);
        setShowDialog(true);
    }

    const showNewDialog = () => {
        setDialogData(getNewConfigObject());
        setShowDialog(true);
    }

    const closeDialog = () => {
        setShowDialog(false);
        setRefreshList(refreshList + 1);
    };

    return (
        <>
            <Row>
                <Col>
                    {table(showEditDialog, refreshList)}
                </Col>
            </Row>
            <Row>
                <Col>
                    {children}
                    <Button className="float-end" variant="primary" onClick={showNewDialog}>Add</Button>
                </Col>
            </Row>

            {dialog(dialogData, setDialogData, showDialog, closeDialog)}
        </>
    );
}

export default CommonConfigPage;